<mat-card class="filter settingHeader">
  <div class="name">
    Manage Custom Info Description
  </div>
  <div class="quickAction">   
   
  </div>
</mat-card>


<div class="documents">

  <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
    <div class="fieldRow head">
      <span class="moveicon"></span>
      <span class="fieldName">Type Name</span>
      <span class="fieldName">Custom Description</span>     
    </div>

    <div class="example-box fieldRow" *ngFor="let task of customInfoStatusList">
      <span class="moveicon"></span>

      <span class="fieldName">{{task.customNoteTypeName}}</span>

      <div class="outerTag" >

        <div class="likeTag" *ngFor="let statuses of task.statuses" >
          {{statuses.customNoteStatusName}}
                     
            <button mat-icon-button (click)="deleteStatusCustomInfo(task,statuses)">
               <mat-icon>close</mat-icon>
              </button>
        
        </div>
               
      </div>

    
    </div>

    
  </mat-card>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>

</div>






<app-loader></app-loader>